import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Menu, X, Instagram, Facebook, Twitter } from 'lucide-react';
export function Header() {
  const location = useLocation();
  const navigate = useNavigate();
  const isHome = location.pathname === '/';
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  useEffect(() => {
    if (isMobileMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isMobileMenuOpen]);
  const navItems = [{
    name: 'Home',
    href: '/'
  }, {
    name: 'About',
    href: '/about'
  }, {
    name: 'Services',
    href: '/services'
  }, {
    name: 'Blog',
    href: '/blog'
  }, {
    name: 'Contact',
    href: '/contact'
  }];
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${isScrolled || !isHome || isMobileMenuOpen ? 'bg-white/95 backdrop-blur-md shadow-sm' : 'bg-transparent'} ${isMobileMenuOpen ? '!bg-[#4A0E0E]' : ''}`} data-id="element-90">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 flex justify-between items-center" data-id="element-91">
        {/* Logo */}
        <Link to="/" className="flex items-center" data-id="element-92">
          <img src="https://cdn.magicpatterns.com/uploads/f1H78FhTX8Y2SRCb3UEDhx/ChatGPT_Image_Jun_12,_2026,_11_15_32_PM.png" alt="Cork Dorx Logo" className={`transition-all duration-500 ${isScrolled || !isHome ? 'h-16 md:h-20 lg:h-24' : 'h-20 md:h-28 lg:h-36'} w-auto object-contain`} data-id="element-93" />
        </Link>

        {/* Desktop Nav */}
        <nav className="hidden xl:flex items-center space-x-6" data-id="element-94">
          <div className="flex items-center space-x-6 mr-2" data-id="element-95">
            {navItems.map(item => {
            const isActive = location.pathname === item.href;
            return <Link key={item.name} to={item.href} className={`nav-link ${isScrolled || !isHome ? isActive ? 'text-[#D4AF37]' : 'text-[#2C2C2C]' : isActive ? 'text-[#D4AF37]' : 'text-white'}`} data-id="element-96">
                  {item.name}
                </Link>;
          })}
          </div>
          <button onClick={() => navigate('/contact')} className={`px-5 py-2 rounded-full transition-all duration-300 ${isScrolled || !isHome ? 'bg-[#4A0E0E] text-white hover:bg-[#D4AF37]' : 'bg-white text-[#4A0E0E] hover:bg-[#D4AF37] hover:text-white'}`} data-id="element-97">
            Book a Tasting
          </button>
        </nav>

        {/* Mobile Toggler */}
        <button className="xl:hidden p-2 relative z-50 transition-transform active:scale-95" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle Menu" data-id="element-98">
          <div className="w-8 h-8 flex items-center justify-center" data-id="element-99">
            {isMobileMenuOpen ? <X className="text-white" size={28} data-id="element-100" /> : <Menu className={isScrolled || !isHome ? 'text-[#2C2C2C]' : 'text-white'} size={28} data-id="element-101" />}
          </div>
        </button>
      </div>

      {/* Mobile Menu */}
      <div className={`fixed inset-0 h-screen bg-[#4A0E0E] z-40 transition-transform duration-500 xl:hidden ${isMobileMenuOpen ? 'translate-x-0' : 'translate-x-full'} pointer-events-none ${isMobileMenuOpen ? 'pointer-events-auto' : ''}`} data-id="element-102">
        <div className="flex flex-col h-full justify-center items-center space-y-8 px-6 text-center" data-id="element-103">
          {navItems.map(item => {
          const isActive = location.pathname === item.href;
          return <Link key={item.name} to={item.href} className={`text-2xl font-serif transition-colors ${isActive ? 'text-[#D4AF37]' : 'text-white hover:text-[#D4AF37]'}`} onClick={() => setIsMobileMenuOpen(false)} data-id="element-104">
                {item.name}
              </Link>;
        })}
          <button onClick={() => {
          setIsMobileMenuOpen(false);
          navigate('/contact');
        }} className="mt-4 px-10 py-4 bg-[#D4AF37] text-white rounded-full font-bold uppercase tracking-widest text-sm" data-id="element-105">
            Book a Tasting
          </button>

          <div className="flex space-x-6 pt-12" data-id="element-106">
            <Instagram className="text-white/60 hover:text-white cursor-pointer" data-id="element-107" />
            <Facebook className="text-white/60 hover:text-white cursor-pointer" data-id="element-108" />
            <Twitter className="text-white/60 hover:text-white cursor-pointer" data-id="element-109" />
          </div>
        </div>
      </div>
    </header>;
}